// eslint-disable-next-line @nx/enforce-module-boundaries
import { TableHeader } from '@occc/ui-design-system';

export const headers: TableHeader[] = [
  { label: 'Member Name' },
  { label: 'Phone Number' },
  { label: 'Entered Date' },
  { label: 'Reason' },
  { label: '' },
];
